<template>
  <div>
    <Header />
    <div class="min-h-screen bg-slate-50 p-4 md:p-8 text-slate-800 font-sans">
      <div class="max-w-[1200px] mx-auto space-y-6">
        <div>
          <div class="flex items-center gap-2 text-sm">
            <button
              @click="$router.back()"
              class="text-gray-500 hover:text-blue-600"
            >
              Student Profile
            </button>

            <svg
              class="w-4 h-4 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              />
            </svg>

            <span class="font-medium text-gray-800">
              {{ pageTitle }}
            </span>
          </div>
        </div>
        <div
          class="bg-white  overflow-hidden"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Admin/Header.vue";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "UserCourse",
  components: { Header },
  data() {
    return {
      courses: [],
      student_id: "",
      student_sem: "",
      student_dep: "",
      token: "",
    };
  },
  mounted() {
    this.student_id = window.atob(this.$route.params.studentid);
    this.student_sem = window.atob(this.$route.params.studentsem);
    this.student_dep = window.atob(this.$route.params.studentdep);
    this.token = window.atob(this.$route.params.tokens);
    // this.getstudentprofile();
    // this.getcourses();
  },
  created() {},
  computed: {
    ...mapGetters(["userInfo"]),
    pageTitle() {
      const routeNames = {
        UserCourse: "My Courses",
      };

      return routeNames[this.$route.name] || "Page";
    },
  },
  methods: {
    // async getstudentprofile() {
    //   try {
    //     const res = await axios.get(
    //       `${process.env.VUE_APP_API}/profile_detail/?Key=${this.token}`,
    //     );
    //     if (res.data) {
    //       this.Students = res.data.data;
    //     } else {
    //       this.Students = [];
    //     }
    //   } catch (err) {
    //     console.error("Error fetching student profile:", err);
    //     this.Students = [];
    //   }
    // },
    // formatDate(date) {
    //   if (!date) return "N/A";
    //   return new Date(date).toLocaleDateString("en-GB", {
    //     day: "2-digit",
    //     month: "short",
    //     year: "numeric",
    //   });
    // },
    // async getcourses() {
    //   try {
    //     const response = await axios.get(
    //       `${process.env.VUE_APP_API}/student-semester-get/${this.student_id}/?Key=${this.token}&semester__id=${this.student_sem}`,
    //     );
    //     if (response.data.data.status === 200) {
    //       const semesterData = response.data.data.data[0].semester[0];
    //       this.courses = semesterData.course
    //         .filter((course) => course.published_course?.published === true)
    //         .map((course) => ({
    //           ...course,
    //           progress: Math.floor(Math.random() * 100) + 1,
    //         }));
    //     } else {
    //       this.courses = [];
    //     }
    //   } catch (err) {
    //     console.error("Error fetching courses:", err);
    //     this.courses = [];
    //   }
    // },
  },
};
</script>
